import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import DarkModeToggle from "../common/DarkModeToggle";
import DropdownMenu from "./DropdownMenu";

const Header = () => {
  const location = useLocation();
  return (
    <>
      {/* 🔹 Top Bar fija con menú a la izquierda y dark mode a la derecha */}
      <div className="fixed w-full h-16 bg-transparent flex items-center justify-between md:px-8 z-50 pt-6">
        <div className="flex items-center">
          <DropdownMenu />
          {location.pathname !== "/" && (
            <header className="ml-4 mt-4">
              <Link to="/">
                <img
                  src={logo}
                  alt="Slowork Logo"
                  className="w-32 sm:w-40 hover:scale-105 transition-transform duration-300"
                />
              </Link>
            </header>
          )}
        </div>
        <DarkModeToggle />
      </div>

      {/* 🔹 Header principal para la ruta "/" */}
      {location.pathname === "/" && (
        <header className="relative flex flex-col items-center justify-center pt-20 sm:pt-24 w-full bg-transparent">
          <img
            src={logo}
            alt="Slowork Logo"
            className="w-56 sm:w-64 md:w-80 lg:w-[500px] xl:w-[600px] h-auto max-w-full"
          />
        </header>
      )}
    </>
  );
};

export default Header;


